{
  "salon-visited-page": {
    "buttons": {
      "book-appointment": "TERMIN BUCHEN"
    },
    "text": {
      "no-visited-salon": "Es kann kein besuchter Salon gefunden werden",
      "promotional-message": "Werbebotschaft",
      "visited-salon": "Besuchte Salons"
    },
    "meta": {
      "title": "Besuchte Salons",
      "description": "Liste der besuchten Salons"
    }
  }
}
